module.exports = __webpack_public_path__ + "static/wlm-logo-display-a284f0ac2492ca46f42d95997101821c.png";